/* ==========================================================
   ARTHUR MUSIC — THEME JS
   Versión limpia: sin panel de edición de Claude Design.
   Solo incluye interacciones reales para el usuario final.
   ========================================================== */

(function(){
  'use strict';

  // ========== Cerrar announcement bar ==========
  var closeBtn = document.querySelector('.b-announce__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(){
      var announce = document.querySelector('.b-announce');
      if (announce) announce.hidden = true;
      try {
        sessionStorage.setItem('arthur-announce-closed', '1');
      } catch(e){}
    });

    // Si ya se cerró en esta sesión, mantenerlo oculto
    try {
      if (sessionStorage.getItem('arthur-announce-closed') === '1') {
        var announce = document.querySelector('.b-announce');
        if (announce) announce.hidden = true;
      }
    } catch(e){}
  }

  // ========== Tabs del grid de productos (visual) ==========
  // Nota: En producción los tabs deberían enlazar a colecciones reales.
  // Este handler solo alterna la clase activa para mantener el look.
  document.querySelectorAll('.arthur-theme-wrapper .tabs').forEach(function(group){
    group.addEventListener('click', function(e){
      var btn = e.target.closest('button');
      if (!btn) return;
      group.querySelectorAll('button').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

})();
